import React from 'react';
import { TabbedForm, useRecordContext } from 'react-admin';
import { EditToolbar } from '../../layout/EditToolbar';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { AssociateCourseDeliveryInputs } from './AssociateCourseDeliveryInputs';
import { AssociateCourseInformationInputs } from './AssociateCourseInformationInputs';

export const AssociateCourseInputs = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    const record = useRecordContext();
    if (record) {
        record.versioningType = null;
    }
    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <TabbedForm
                {...props}
                //validate={validate}
                toolbar={<EditToolbar />}
            >
                <AssociateCourseInformationInputs {...props} />
                <AssociateCourseDeliveryInputs {...props} />
            </TabbedForm>
        </ReadOnlyContext.Provider>
    );
};

const validate = (values) => {
    const errors = {};
    if (!values.Title) {
        errors.Title = 'Title is required';
    }
    if (!values.approvedDate) {
        errors.approvedDate = 'Approved date is required';
    }
    if (!values.dateClosed) {
        errors.dateClosed = 'Closed date is required';
    }

    if (values.validationTo < values.validationFrom) {
        errors.validationTo = 'Validation to cannot be before validation from';
    }

    if (values.id && !values.versioningType) {
        errors.versioningType = 'Version type is required';
    }
    return errors;
};
